import api from "./ApiMiddleware";
export default [
    api
];
